import { useDispatch } from "react-redux";

import { get_orders } from "../api";
import { ordersSelector } from "../selectors";
import { set_orders_action } from "../actions";
import useReduxSwr from "../../global/hooks/useReduxSwr";
import { Order } from "../../../types/server";

export default useOrdersList;

function useOrdersList() {
  let dispatch = useDispatch();
  let { data, isValidating, error, revalidate } = useReduxSwr<Order[]>({
    fetcher: get_orders,
    selector: ordersSelector,
    onFinished: (data) => {
      dispatch(set_orders_action(data));
    },
    enabled: false,
  });

  return {
    data,
    error: error,
    isValidating,
    revalidate,
  };
}
